export default {
  isRoot: state => state.user && state.user.isRoot,
  canConnectToSocket: state => state.canConnectToSocket,
  canUseUserOnlineChecker: state => state.canUseUserOnlineChecker,
  getUserSocketConnection: state => state.userSocketConnection,
  getIntegratorSocketConnection: state => state.integratorSocketConnection,
}
